import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup" }
const _hoisted_2 = { class: "as-h2-title-box" }
const _hoisted_3 = { class: "as-h2-title-box" }

import { ref, computed } from "vue";
import type { IH2h, IMatch } from "~src/interfaces";
import H2hTab from "~src/components/h2h/H2hTab.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  h2h: IH2h;
  match: IMatch;
  isTabCenter?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2hList',
  props: {
    h2h: {},
    match: {},
    isTabCenter: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("vs");

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: "Toàn bộ",
    key: "vs",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const h2hVs = computed(() => {
  if (!props.h2h.vs || props.h2h.vs?.length === 0) return [];

  return props.h2h.vs.filter((item: any) => {
    if (activeTab.value === "home") {
      return props.match.home_team?.id === item[5][0];
    }
    if (activeTab.value === "away") {
      return props.match.home_team?.id === item[6][0];
    }

    return true;
  });
});

const h2hHome = computed(() => {
  if (!props.h2h.home || props.h2h.home?.length === 0) return [];

  return props.h2h.home.filter((item: any) => {
    let check = !props.h2h.vs.find((vsi: any) => item[0] === vsi[1]);
    if (check && activeTab.value === "home") {
      check = props.match.home_team?.id === item[5][0];
    }

    return check;
  });
});

const h2hAway = computed(() => {
  if (!props.h2h.away || props.h2h.away?.length === 0) return [];

  return props.h2h.away.filter((item: any) => {
    let check = !props.h2h.vs.find((vsi: any) => item[0] === vsi[1]);
    if (check && activeTab.value === "away") {
      check = props.match.away_team?.id === item[6][0];
    }

    return check;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    { 'as-tab-btn-center': _ctx.isTabCenter },
    `as-parent-h2h as-parent-h2h-${siteName.value}`
  ])
  }, [
    _createVNode(TabsBtn, {
      tabs: tabs.value,
      activeTab: activeTab.value,
      onChange: changeTab,
      isShowBorder: true
    }, null, 8, ["tabs", "activeTab"]),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "as-h2-title-box" }, "Các trận đối đầu", -1)),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hVs.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.competitions,
          match: _ctx.match,
          tab: "all",
          homeTeamId: _ctx.match.home_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value === 'vs']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_2, " Các trận gần nhất: " + _toDisplayString(_ctx.match.home_team.name), 1),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hHome.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.competitions,
          match: _ctx.match,
          tab: "home",
          homeTeamId: _ctx.match.home_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value !== 'away']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, " Các trận gần nhất: " + _toDisplayString(_ctx.match.away_team.name), 1),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hAway.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.competitions,
          match: _ctx.match,
          tab: "away",
          homeTeamId: _ctx.match.away_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value !== 'home']
      ])
    ])
  ], 2))
}
}

})